// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
const {
    recordProcess,
    PROC_END,
    PROC_FAIL,
    PROC_RA_CANCEL_SERVICE,
} = require('utilities/tagging');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const raErrorHandlerActions = require('./RAErrorHandler');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');

// @constants
const { DATE_FORMAT_API, EURO_TEXT } = require('constants/index');
const actionTypes = require('../raConstants/actionTypes');

const reset = () => ({
    type: actionTypes.RA_CANCEL_PLAN_RESET,
});

const cancelPlanSuccess = () => ({
    type: actionTypes.RA_CANCEL_PLAN_SUCCESS,
});

const cancelPlanInProgress = () => ({
    type: actionTypes.RA_CANCEL_PLAN_IN_PROGRESS,
});

const cancelPlanFailure = error => ({
    type: actionTypes.RA_CANCEL_PLAN_FAILURE,
    payload: {
        error,
    },
});

const cancelPlan = (portfolioId, dataToken, history) => (
    dispatch,
    getState,
) => {
    const immGlobalPosition = getState().raGlobalPosition;
    const immPortfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);
    const query = {
        dataToken,
    };

    if (immPortfolio.has('recurringTransfers')) {
        const immAccount = immGlobalPosition.getIn([
            'roboAccount',
            portfolioId,
        ]);
        const nextDate = immPortfolio.getIn([
            'recurringTransfers',
            'nextTransferDate',
        ]);
        const nextDateFormatted = !nextDate
            ? '9999-12-31'
            : DateHelper.formatDate(nextDate, DATE_FORMAT_API);

        query.recurringTransfer = {
            contratoOrdenante: {
                numerodecontrato: immPortfolio.getIn([
                    'recurringTransfers',
                    'originalAccount',
                    'contrato',
                ]),
                producto: immPortfolio.getIn([
                    'recurringTransfers',
                    'originalAccount',
                    'documento',
                ]),
            },
            cuentaDestino:
                immAccount.getIn(['ibanComplex', 'pais']) +
                immAccount.getIn(['ibanComplex', 'digitodecontrol']) +
                immAccount.getIn(['ibanComplex', 'codbban']),
            fechaProximaEjecucion: nextDateFormatted,
            importe: {
                divisa: EURO_TEXT,
                importe: immPortfolio.getIn(['recurringTransfers', 'amount']),
            },
            indicadorDifPerio: 'P',
            numeroOrdenCabecera: immPortfolio.getIn([
                'recurringTransfers',
                'paymentReference',
            ]),
        };
    }

    const params = {
        portfolioId,
    };

    const request = {
        query,
    };

    const customData = {
        processDetail: 'robo cartera ' + immPortfolio.get('name'),
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raCancelAccount', params),
        request,
    )
        .then(() => {
            dispatch(cancelPlanSuccess());
            dispatch(outdateMyInvestments());

            recordProcess(PROC_RA_CANCEL_SERVICE, PROC_END, customData);
        })
        .catch(error => {
            if (error.error) {
                dispatch(cancelPlanFailure(error.error.description));
            } else {
                throw error;
            }

            dispatch(raErrorHandlerActions.show(error, history));
            recordProcess(PROC_RA_CANCEL_SERVICE, PROC_FAIL, customData);
        });
};

const finish = (history, portfolioId) => (dispatch, getState) => {
    const cancelPlanCallback = (dispatch, _, dataToken) => {
        dispatch(cancelPlan(portfolioId, dataToken, history));
    };

    dispatch(cancelPlanInProgress());
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        cancelPlanCallback,
    );
};

module.exports = {
    finish,
    reset,
};
